@if (visible) {
  <div class="cookie-banner" role="dialog" aria-label="Cookie consent">
    <div class="cookie-banner__content">
      <div class="cookie-banner__text">
        <p class="cookie-banner__title">We use cookies</p>
        <p class="cookie-banner__message">
          Kirigami uses cookies to keep you signed in and to remember your preferences. We don't
          sell your data.
        </p>
      </div>
      <div class="cookie-banner__actions">
        <kirigami-button
          label="DISMISS"
          ariaLabel="Dismiss cookie banner"
          size="compact"
          (onClick)="dismissed.emit()"
        ></kirigami-button>
        <kirigami-button
          label="ACCEPT ALL"
          ariaLabel="Accept all cookies"
          size="compact"
          [filled]="true"
          (onClick)="accepted.emit()"
        ></kirigami-button>
      </div>
    </div>
  </div>
}
